import { PartitionLoopCompareJCountElementPivotState } from "./PartitionLoopCompareJCountElementPivotState";
import { PartitionSwapPivotICountPlusState } from "./PartitionSwapPivotICountPlusState";
import { assertIsDefined } from "../../../tsutils/assertIsDefined";
import { IQuickSortState } from "../../IQuickSortState";
import { QuickSortStep } from '../../enums/QuickSortStep';
import { IQuickSortContext } from '../../IQuickSortContext';

export class PartitionLoopCompareJCountHIState implements IQuickSortState {
  
  ThisQuickSortStep = QuickSortStep.PartitionLoopCompareJCountHI;

  Description = "Compare j value with HI value";

  private _savedState : { ComparisonResult : boolean | undefined } | undefined;

  private _context : IQuickSortContext | undefined;

  SetContext(context: IQuickSortContext): void {
    this._context = context;
  }  
  
  Do(): void {
    let result : boolean = false;
    
    if (this._context && this._context.JCount !== undefined && this._context.Hi !== undefined) {
      result = this._context.JCount <= this._context.Hi - 1;
      if (this._savedState === undefined) {
        this._savedState = {
          ComparisonResult: result
        }
      }
      else {
        this._savedState.ComparisonResult = result;
      }
    }
  }

  Undo(): void {
    if (this._savedState) {
      this._savedState.ComparisonResult = undefined;
    }
  }

  Exit(): void {
    if (this._context !== undefined) {
      if (this._savedState?.ComparisonResult) {
        this._context.TransitionTo(new PartitionLoopCompareJCountElementPivotState());
      }
      else {
        this._context.TransitionTo(new PartitionSwapPivotICountPlusState());
      }
    }
  }
}